<template>
  <div class="chart-wrapper">
    <v-card class="mx-auto" max-width="400" height="280px">
      <v-card-title class="title" v-if="title">{{title}}</v-card-title>
      <v-card-text v-if="datasets.length>0 && Object.keys(this.labels).length>0">
        <chart-view :type="chartType" :labels="chartLabels" :datasets="datasets" :options="options"></chart-view>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ChartView from "../components/ChartView.vue";
export default {
  name: "DoughnutChart",
  components: {
    ChartView
  },
  props: ["title", "labels", "data"],
  data() {
    return {
      chartType: "doughnut",
      datasets: [],
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          labels: {
            fontColor: "#333",
            boxWidth: 5,
            padding: 25,
            usePointStyle: true
          }
        },
        tooltips: {
          mode: "index",
          intersect: false
        },
        hover: {
          mode: "nearest",
          intersect: true
        }
      }
    };
  },
  computed: {
    chartLabels() {
      if (this.labels.length > 0) {
        return this.labels.map(val => " " + val);
      } else return [];
    }
  },
  watch: {
    data() {
      this.datasets = [];
      if (this.data.length > 0) {
        this.datasets.push({
          label: "Employee Count",
          data: this.data,
          borderColor: this.getColors(),
          borderWidth: 10,
          weight: 0
        });
      }
    }
  },
  methods: {
    getColors() {
      return this.labels.map(val => this.stringToColour(val));
    },
    stringToColour(str) {
      str = str + Math.random();
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      let colour = "#";
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
      }
      return colour;
    }
  }
};
</script>

<style scoped>
.chart-wrapper {
  min-width: 200px;
  width: 400px;
}
</style>